import { httpMethods } from '../types.js';

/**
 * Takes a dereferenced OpenAPI document and returns all operations.
 * Ignores other attributes, like summary, parameters, etc.
 */
function getOperations(path) {
    const operations = {};
    for (const method of httpMethods) {
        if (path?.[method]) {
            operations[method] = path?.[method];
        }
    }
    return operations;
}

export { getOperations };
